<form #f="ngForm" autocomplete="off" (submit)="saveSling(true,f)" class="dialog-form">
    <div class="form-group basic">
         <div class="form-control">
            <div *ngIf="!isASlingEdition">
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                    <div style="display: flex; align-items: center; gap: 20px;">
                        <label style="margin: 0; font-weight: 600;">Pesquisar por:</label>
                        <div style="display: flex; gap: 20px;">
                            <div style="display: flex; align-items: center;">
                                <input type="radio" id="searchByCustomer" name="searchType" [value]="'customer'" 
                                    [checked]="searchByCustomer === true" (change)="changeSearchType('customer')" 
                                    style="margin-right: 6px; cursor: pointer;">
                                <label for="searchByCustomer" style="margin: 0; cursor: pointer; font-weight: normal;">Cliente</label>
                            </div>
                            <div style="display: flex; align-items: center;">
                                <input type="radio" id="searchByBoat" name="searchType" [value]="'boat'" 
                                    [checked]="searchByCustomer === false" (change)="changeSearchType('boat')" 
                                    style="margin-right: 6px; cursor: pointer;">
                                <label for="searchByBoat" style="margin: 0; cursor: pointer; font-weight: normal;">Embarcação</label>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="sling.navigationPlan.responsible.federalId && sling.navigationPlan.responsible.federalId.trim() !== ''">
                        <label style="color: #bbb; font-weight: 600;">{{ 'FEDERAL-ID.GENERAL' | translate }}: {{ sling.navigationPlan.responsible.federalId }}</label>
                    </div>
                </div>
                
                <div *ngIf="searchByCustomer === true">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                        <div>
                            <label>{{ 'CUSTOMER' | translate }}</label>
                        </div>
                    </div>
                    <p-dropdown placeholder="Selecione o cliente..." [disabled]="isASlingEdition" required [filter]="true" appendTo="body"
                        [options]="customerOptions" [(ngModel)]="selectedCustomerId" name="selectedCustomerId"
                        (onChange)="handleCustomerSelection()" filterBy="label">
                        <ng-template let-option pTemplate="selectedItem">
                            <span [ngStyle]="{'color': option?.disabled ? 'red' : '#222222' }">
                                {{option.label}}
                            </span>
                        </ng-template>
                        <ng-template let-option pTemplate="item">
                            <div [ngStyle]="{'padding': isToten && '5px 0px'}">
                                {{option.label}}
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
                
                <div *ngIf="searchByCustomer === false">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                        <div>
                            <label>{{ 'BOAT' | translate }}</label>
                        </div>
                    </div>
                    <p-dropdown placeholder="Selecione a embarcação..." [disabled]="isASlingEdition" required [filter]="true" appendTo="body"
                        [options]="boatOptions" [(ngModel)]="selectedBoatId" name="selectedBoatId"
                        (onChange)="handleBoatSelection()" filterBy="label">
                        <ng-template let-option pTemplate="selectedItem">
                            <span [ngStyle]="{'color': option?.disabled ? 'red' : '#222222' }">
                                {{option.label}}
                            </span>
                        </ng-template>
                        <ng-template let-option pTemplate="item">
                            <div [ngStyle]="{'padding': isToten && '5px 0px'}">
                                {{option.label}}
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
                
                <div *ngIf="searchByCustomer === true && selectedCustomerId">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; margin-top: 12px;">
                        <div>
                            <label>{{ 'BOAT' | translate }}</label>
                        </div>
                    </div>
                    <p-dropdown placeholder="Selecione a embarcação..." [disabled]="isASlingEdition" required [filter]="true" appendTo="body"
                        [options]="customerBoatOptions" [(ngModel)]="selectedBoatId" name="selectedBoatIdCustomer"
                        (onChange)="handleBoatSelection()" filterBy="label">
                        <ng-template let-option pTemplate="selectedItem">
                            <span [ngStyle]="{'color': option?.disabled ? 'red' : '#222222' }">
                                {{option.label}}
                            </span>
                        </ng-template>
                        <ng-template let-option pTemplate="item">
                            <div [ngStyle]="{'padding': isToten && '5px 0px'}">
                                {{option.label}}
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
                
                <div *ngIf="searchByCustomer === false && selectedBoatId">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; margin-top: 12px;">
                        <div>
                            <label>{{ 'CUSTOMER' | translate }}</label>
                        </div>
                    </div>
                    <p-dropdown placeholder="Selecione o cliente..." [disabled]="isASlingEdition" required [filter]="true" appendTo="body"
                        [options]="boatCustomerOptions" [(ngModel)]="selectedCustomerId" name="selectedCustomerIdBoat"
                        (onChange)="handleCustomerSelection()" filterBy="label">
                        <ng-template let-option pTemplate="selectedItem">
                            <span [ngStyle]="{'color': option?.disabled ? 'red' : '#222222' }">
                                {{option.label}}
                            </span>
                        </ng-template>
                        <ng-template let-option pTemplate="item">
                            <div [ngStyle]="{'padding': isToten && '5px 0px'}">
                                {{option.label}}
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
            </div>
            
            <div *ngIf="isASlingEdition">
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; margin-top: 30px;">
                    <div>
                        <label>{{ 'CUSTOMER_OR_BOAT' | translate }}</label>
                    </div>
                    <div *ngIf="sling.navigationPlan.responsible.federalId && sling.navigationPlan.responsible.federalId.trim() !== ''">
                        <label style="color: #bbb; font-weight: 600;">{{ 'FEDERAL-ID.GENERAL' | translate }}: {{ sling.navigationPlan.responsible.federalId }}</label>
                    </div>
                </div>
                <p style="padding: 5px; background-color: #f5f5f5; border-radius: 4px; border: 1px solid #ddd; margin: 0; height: 30px;">
                    {{sling.navigationPlan.responsible.id}} <fa-icon [icon]="'user'" style="margin-right: 5px;"></fa-icon> 
                    {{sling.navigationPlan.responsible.name}} - {{ sling.navigationPlan.responsible.accessGroup?.name }} / 
                    <fa-icon [icon]="'ship'" style="margin-right: 3px;"></fa-icon> {{sling.boat.name}}
                </p>
            </div>  
        </div>

        <div class="form-control" *ngIf="enabledSailor()">
            <div class="space"></div>
          <label>{{'SAILOR' | translate}}</label>
          <p-dropdown placeholder="Selecione..." [disable]="isASlingEdition" [filter]="!isToten"
          appendTo="body" [options]="sailors" [(ngModel)]="selectedSailorId" name="selectedSailorId"
          emptyFilterMessage="" (onChange)=" selectSailor()">
            <ng-template let-sailor pTemplate="item">
              <div>{{sailor.label}}</div>
            </ng-template>
          </p-dropdown>
        </div>
    </div>
    <!-- EAS-245: embarcação adicional no mesmo agendamento. Só com a chave da marina ligada, cliente e
         embarcação principal escolhidos e adicionais elegíveis; sem isso nada é renderizado. -->
    <div class="form-group additional-boats"
        *ngIf="showAdditionalBoats()">
        <div class="form-control">
            <div style="display: flex; justify-content: space-between; align-items: center;">
                <label>{{ 'Embarcação adicional' | translate }}</label>
                <small *ngIf="suggestAdditionalBoat" style="color: #f0a020; font-weight: 600;">Sugerido</small>
            </div>
            <p-multiSelect appendTo="body" [options]="additionalBoatOptions"
                [(ngModel)]="selectedAdditionalBoatIds" name="selectedAdditionalBoatIds"
                [selectionLimit]="maxAdditionalBoats" optionLabel="label" optionValue="value"
                [disabled]="!isPendingDown()" [style]="{'width':'100%'}"
                placeholder="Embarcações adicionais do mesmo cliente..."
                emptyFilterMessage="Nenhuma embarcação disponível"
                (onChange)="onChangeAdditionalBoats()">
                <ng-template let-option pTemplate="item">
                    <span [ngStyle]="{'color': option?.disabled ? 'red' : '#222222' }">{{ option.label }}</span>
                </ng-template>
            </p-multiSelect>
            <small style="color: #888;">Limite: {{ maxAdditionalBoats }}. Cada embarcação gera uma movimentação própria.</small>
        </div>
    </div>
    <br>
    <div class="form-group">
        <div class="to-confirm-manual-hour-container">
        </div>
        
        <div class="form-control forecast">
            <label for="requestDate">{{ 'CHOOSE-DATE' | translate }}</label>
            <div class="form-group">
                <p-calendar dateFormat="dd/mm/y" name="requestDate" [readonlyInput]="true" [minDate]="startDate"
                    appendTo="body" [(ngModel)]="requestDate" [showIcon]="true" i18n [disabled]="!isPendingDown()"
                    (onSelect)="changeExecutionForecast($event)" required styleClass="forecast-date">
                </p-calendar>
                <div class="day-name">
                    <span>{{pt.dayNames[requestDate.getDay()]}}</span>
                </div>
            </div>
        </div>
        <div class="form-control">
            <label>Hr saída</label>
            <div style="display: flex; align-items: center;">
                <p-dropdown placeholder="Selecione..." [filter]="true" [options]="availablePeriods" appendTo="body"
                    [(ngModel)]="sling.executionForecast" name="executionForecast" [required]="!manualHour"
                    [disabled]="!isPendingDown()" *ngIf="!manualHour && availablePeriods" (onHide)="getAvailablePeriodsSlingUp()" style="flex: 1;">
                </p-dropdown>
                <input pInputText type="time" [style]="{display: 'block', width: '100%'}" name="executionForecast"
                    [disabled]="!isPendingDown()" [(ngModel)]="executionForecast" [required]="manualHour"
                    *ngIf="manualHour" style="flex: 1;">
                <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm" 
                    [disabled]="!isPendingDown()" (click)="manualHour = !manualHour" 
                    style="margin-left: 5px;" [ngClass]="{'p-button-info': manualHour}"
                    pTooltip="{{manualHour ? 'Voltar para seleção automática' : 'Editar horário manualmente'}}" tooltipPosition="top">
                </button>
                <span style="color: red; margin-left: 5px;" *ngIf="hasClosed()">*</span>
            </div>
        </div>
    </div>
    <div class="divider"></div>
    <p-fieldset>
        <p-header class="article-title">
            <span class="article-title">{{'NAVIGATION-PLAN' | translate}}</span>
        </p-header>
        <div class="form-group">
          <div class="form-control">
            <label>{{ getLabelPassengers() }}</label>
            <app-passengers
              [(ngModel)]="sling.navigationPlan.crewQty"
              [typePeople]="hasChild ? 'Adult' : 'Person'"
              name="crewQty"
              [totalPassengers]="totalPassagers - (sling.navigationPlan.childQty ? sling.navigationPlan.childQty : 0)">
            </app-passengers>
          </div>
          <div class="form-control" *ngIf="hasChild">
            <label>{{ 'CHILDREN' | translate }}</label>
            <app-passengers
              [(ngModel)]="sling.navigationPlan.childQty"
              [typePeople]="'Child'"
              name="childQty"
              [totalPassengers]="totalPassagers - (sling.navigationPlan.crewQty ? sling.navigationPlan.crewQty : 0)">
            </app-passengers>
          </div>
          <div class="form-control">
            <label style="display: flex; align-items: center; justify-content: space-between;">
              <span>{{ 'DESTINATION' | translate }}</span>
              <span (click)="showMultiplesDestination()" class="link">múltiplos destinos</span>
            </label>
            <div class="form-group">
              <input type="text" pInputText [(ngModel)]="sling.navigationPlan.destination"
                class="input-destination" [ngModelOptions]="{standalone: true}"
                [required]="slingConfig.navigationPlanRequiredWeb">
              <p-dropdown placeholder="Favoritos" [filter]="true" [options]="frequentFestinations"
                styleClass="destinations-dropdown" [(ngModel)]="sling.navigationPlan.destination"
                name="frequentFestinations" class="flex1" emptyFilterMessage="" dropdownIcon="pi pi-star"
                id="dropdown-icon-fav" appendTo="body">
                </p-dropdown>
            </div>
          </div>
            <div class="form-control">
                <label>{{ 'RETURN-DATE' | translate }}</label>
                <p-calendar dateFormat="dd/mm/yy" name="returnDate" [readonlyInput]="true" [minDate]="minReturnDate"
                    [(ngModel)]="returnDate" [showIcon]="true" i18n (onSelect)="getAvailablePeriodsSlingUp()" required
                    appendTo="body">
                </p-calendar>
            </div>
            <div class="form-control">
                <label>{{ 'RETURN-TIME' | translate }}</label>
                <div style="display: flex; align-items: center;">
                    <p-dropdown placeholder="Selecione..." [filter]="!isToten" [options]="availablePeriodsSlingUp"
                        [(ngModel)]="sling.navigationPlan.returnTime" [required]="!manualHour" appendTo="body" emptyFilterMessage=""
                        name="navigationPlan.returnTime" *ngIf="!manualHour" style="flex: 1;">
                    </p-dropdown>
                    <input pInputText type="time" [style]="{display: 'block', width: '100%'}" name="navigationPlanReturnTime"
                        [(ngModel)]="navigationPlanReturnTime" [required]="manualHour" *ngIf="manualHour" style="flex: 1;">
                </div>
            </div>
        </div>

        <p-footer>
            <div class="form-group">
                <div class="form-control">
                    <div class="float-left" *ngIf="sling.id">
                        <p style="font-weight:600; padding-left: 20px">Data do pedido:
                            {{getRequestDate() | date: "dd/MM/yyyy HH:mm"}}</p>
                    </div>
                    <div class="float-left">
                        <p style="font-weight:600; padding-left: 20px; color: red" *ngIf="hasClosed()"> *Utilize o
                            horário manual caso necessário!</p>
                    </div>
                </div>
                <div class="buttons">
                    <button *ngIf="sling.slingStatus == 'PENDING_DOWN'" class="easymarine danger" type="button"
                        (click)="close()">{{ 'CANCEL' | translate }}</button>
                    <button [disabled]="disableFlag  || (!slingConfig?.hasFuelSupply
                        && !slingConfig?.hasConsumables && !slingConfig?.hasAccessories)" (click)="saveSlingData(false,f)"
                        class="easymarine" type="button">
                        {{ 'NEXT' | translate }}
                    </button>
                    <button [disabled]="disableFlag || !hasEdit(sling)" class="easymarine primary"
                        type="submit">
                        {{ 'SAVE' | translate }}
                    </button>
                </div>
            </div>
        </p-footer>
    </p-fieldset>
    <div class="message-day" [ngClass]="messageDayExecutionForecast.type === 'SpecialDay'? 'warn':'danger'"
        *ngIf="messageDayExecutionForecast">
        <fa-icon class="icon" [icon]="'exclamation-circle'"></fa-icon>
        <h5>
            <span *ngIf="!hasMessageDayInEqualsDays()"> {{ 'CHOOSE-DATE' | translate }} - </span>
            {{messageDayExecutionForecast.date | date: 'dd/MM/yy'}} - {{messageDayExecutionForecast.message}}
        </h5>

    </div>
    <div class="message-day" [ngClass]="messageDayReturnDate.type === 'SpecialDay'? 'warn':'danger'"
        *ngIf="showMessageDayReturnDate()">
        <fa-icon class="icon" [icon]="'exclamation-circle'"></fa-icon>
        <h5>
            <span *ngIf="!hasMessageDayInEqualsDays()"> {{ 'RETURN-DATE' | translate }} - </span>
            {{messageDayReturnDate.date | date: 'dd/MM/yy'}} - {{messageDayReturnDate.message}}
        </h5>
    </div>
</form>
